import z from 'zod';

export const ZFormQueryParams = z.object({
  sellerId: z.string(),
});
